const FALLBACK_PATH = '/products';

export const withReturnUrl = (path, location) =>
	`${path}?returnUrl=${encodeURIComponent(`${location.pathname}${location.search}`)}`;

export const readReturnUrl = (search) => {
	const raw = new URLSearchParams(search).get('returnUrl');

	return raw && /^\/(?![/\\])/.test(raw) ? raw : FALLBACK_PATH;
};
